import { requestConfig } from "../config.js";

/**
 * Создать услуги
 *
 * @param {String} apiKey
 * @param {?Number} inetTariffId
 * @param {?Boolean} hasCable
 * @param {?Boolean} hasCtv
 * @param {?Boolean} hasIptv
 * @param {?Array<String>} cctv
 * @param {?String} passphrase
 */
export async function apiCreateServices(
  apiKey,
  inetTariffId = null,
  hasCable = null,
  hasCtv = null,
  hasIptv = null,
  cctv = null,
  passphrase = ""
) {
  await requestConfig.post("/api/v0/master/mobile_connect/create_services/", {
    key: apiKey,
    inet: inetTariffId,
    has_cable: hasCable,
    ctv: typeof hasCtv === "object" && hasCtv !== null ? true : hasCtv,
    iptv: typeof hasIptv === "object" && hasIptv !== null ? true : hasIptv,
    cctv: cctv,
    code_phrase: !passphrase.length ? null : passphrase,
  });
}
